import axiosConfig from "./axiosConfig";

interface HhDataTempUploadUrlRequest {
  fileName: string;
  contentType: string;
}

interface HhDataTempUploadUrlResponse {
  url: string;
  fileGuid: string;
}

const postHhDataTempUploadUrl = async (
  authToken: string,
  request: HhDataTempUploadUrlRequest
): Promise<HhDataTempUploadUrlResponse> => {
  const { data } = await axiosConfig.post(`/hh_data/temp`, request, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default postHhDataTempUploadUrl;
